module.exports = __webpack_public_path__ + "static/img/sarrut.9322f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sarrut.jpg
// module id = ILa6
// module chunks = 2